// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clipboard {
  font-size: 14px;
  font-family: Montserrat-Light;
  color: #777777;
  cursor: pointer;
}
.clipboard.disabled {
  color: #999999;
  cursor: not-allowed;
}
.clipboard {
  font-size: 14px;
  color: #999999;
  background-image: url('unselected-clip.099587351d368f59.svg');
  background-position: left;
  background-repeat: no-repeat;
  padding-left: 20px;
}
.clipboard :hover {
  color: #7F6C2E;
  background-image: url('hover-clip.0ebbd209d6e8a1bb.svg');
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/copy-to-clipboard/copy-to-clipboard.component.less"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AADJ;AAGI;EACI,cAAA;EACA,mBAAA;AADR;AAMA;EACI,eAAA;EACA,cAAA;EACA,6DAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;AAJJ;AAFA;EASQ,cAAA;EACA,wDAAA;AAJR","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.clipboard {\n    font-size: 14px;\n    font-family: Montserrat-Light;\n    color: @placeholder;\n    cursor: pointer;\n\n    &.disabled {\n        color: @secondary-60;\n        cursor: not-allowed;\n    }\n}\n\n\n.clipboard {\n    font-size: 14px;\n    color: @secondary-60;\n    background-image: url(../../styles/img/unselected-clip.svg);\n    background-position: left;\n    background-repeat: no-repeat;\n    padding-left: 20px;\n\n    :hover {\n        color: @primary-base;\n        background-image: url(../../styles/img/hover-clip.svg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
